import { createAction } from 'typesafe-actions'

export type PurchaseMode = 'purchase' | 'leasing'

export const changePurchaseMode = createAction('CMD / PurchaseMode / change')<PurchaseMode>()

export const setPurchaseModeState = createAction('DOC / PurchaseMode / set state')<PurchaseMode>()
